import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { addTemporaryToast } from "shared/components/Toast";
import { IAPIState, IStatus } from "shared/types";
import { DeleteModal, Modal } from "shared/components";
import { copy } from "shared/assets";

import { dataMetaSelector, deleteEvent } from "Bands/state";
import { BAND_ACTIONS, IEvent } from "Bands/types";
import { useEventContext } from "Bands/contexts";
import { BAND_PATHS } from "Bands/router";
import { useBandRoute, useClearActionMetaOnUnMount } from "Bands/utils";

const deleteEventCopy = copy.event.delete;

interface DeleteEventModalProps {
  handleClose: () => void;
  forceDeleteEvent?: IEvent;
  onDeleteSuccess?: () => void;
}

export const DeleteEventModal: React.FC<DeleteEventModalProps> = ({
  handleClose,
  forceDeleteEvent,
  onDeleteSuccess,
}) => {
  const dispatch = useDispatch();

  const { eventId, event } = useEventContext();
  const { pushRoute } = useBandRoute();

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.deleteEvent));

  useClearActionMetaOnUnMount(BAND_ACTIONS.deleteEvent);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      onDeleteSuccess && onDeleteSuccess();

      handleClose();
      pushRoute(BAND_PATHS.BAND_CALENDAR);
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: deleteEventCopy.success,
        })
      );
    }
  }, [dispatch, apiMeta, handleClose, pushRoute, onDeleteSuccess]);

  const handleDelete = () => {
    const toDeleteEvent = forceDeleteEvent?.id || eventId;

    toDeleteEvent && dispatch(deleteEvent(toDeleteEvent));
  };

  return (
    <Modal data-testid="event_delete_modal">
      <DeleteModal
        name={forceDeleteEvent?.title || event?.title || ""}
        handleClose={handleClose}
        handleDelete={handleDelete}
        apiMeta={apiMeta}
        type="event"
      />
    </Modal>
  );
};
